import React from 'react';
import { IndexRedirect, Redirect } from '@americanexpress/one-app-router';
import ModuleRoute from 'holocron-module-route';
import WrapperViewAll from './pages/view-all';
import WrapperDetails from './pages/details';
import WrapperEnroll from './pages/enroll';
import WrapperTerms from './pages/terms';

export default function getChildRoutes() {
  return (
    <ModuleRoute>
      <IndexRedirect to="view-all" title="Benefits Dashboard" />
      <ModuleRoute path="view-all(/:cardname)" title="Benefits Dashboard" component={WrapperViewAll} />
      <ModuleRoute path="enroll/:benname/:cardname" title="Benefits Dashboard" component={WrapperEnroll} />
      <ModuleRoute path="detail/:benname(/:cardname)" title="Benefits Dashboard" component={WrapperDetails} />
      <ModuleRoute path="terms(/:cardname)" title="Benefits Dashboard" component={WrapperTerms} />
      <Redirect from="*" to="view-all" />
    </ModuleRoute>
  );
}
